export const PointSection = () => {
  return (
    <>
      <div className="bg-secondary w-full mx-auto flex items-center">
        <img src="/assets/top-thumba-logo.svg" alt="Main Content Background" className="absolute" />
        <div className="text-center text-white flex-1">
          <div className="border-t border-white w-[120px] mx-auto mt-4" />
          <p className="text-sm font-semibold">POINT 3</p>
          <div className="border-t border-white w-[120px] mx-auto" />
          <h2 className="text-xl sm:text-2xl font-bold mb-4">サンバの推しポイント３選</h2>
        </div>
      </div>
      <div className="bg-white w-full mx-auto items-center">
        <div className="items-center py-8">
          <img
            src="/assets/top-point-01.png"
            alt="Main Content Background"
            className="mb-4 w-[90%] max-w-[370px] mx-auto"
          />
          <img
            src="/assets/top-point-02.png"
            alt="Main Content Background"
            className="mb-4 w-[90%] max-w-[370px] mx-auto"
          />
          <img src="/assets/top-point-03.png" alt="Main Content Background" className="w-[90%] max-w-[370px] mx-auto" />
        </div>
      </div>
    </>
  );
};
